module.exports = __webpack_public_path__ + "static/media/SONIDO_ACIERTO.1a04e55a.mp3";